import MediaService from '@/services/MediaService';
import { defineStore } from 'pinia';

export const useMediaStore = defineStore('media', {
  state: () => ({}),

  getters: {},

  actions: {
    async refreshMedia(uuid: Id) {
      const [data, error] = await MediaService.show(uuid);

      if(error) {
        throw error;
      }

      return data;
    },

    async deleteMedia(uuid: Id) {
      const [data, error] = await MediaService.delete(uuid);

      if(error) {
        throw error;
      }

      return data;
    },

    async downloadMedia(uuid: Id) {
      const [data, error] = await MediaService.download(uuid);

      if(error) {
        throw error;
      }

      return data;
    },

    async updateSettings(uuid: Id, form: ApiRequests['api.v1.media.settings.update']) {
      const [data, error] = await MediaService.updateSettings(uuid, form);

      if(error) {
        throw error;
      }

      return data;
    },
  },
});
